import { useEffect } from 'react';
import { useHomeViewModel } from './home.viewModel';
import { registerContext } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { HomeView } from './Home.view';
import { useUser } from '@client/new/hooks/use-user';
import { useOnboardingGuard } from '@client/new/pages/onboarding';
import { PATHS } from '@client/routes';
import { navigate } from '@client/new/helpers/history';

export const homeVM = registerContext('homeVM', useHomeViewModel);

export const HomePage = (p: { params: { influencerId?: string } }) => {
  const { user, influencer } = useUser();

  const creatorId = influencer?.id ?? user?.influencerId ?? null;
  const creatorPublishedAt = influencer?.publishedAt ?? null;

  const guard = useOnboardingGuard(creatorId, creatorPublishedAt);

  useEffect(() => {
    if (guard.type === 'fetched' && guard.value.shouldRedirectToOnboarding) {
      const onboardingPath = p.params.influencerId
        ? PATHS.ONBOARDING_ADMIN(Number(p.params.influencerId))
        : PATHS.ONBOARDING;
      navigate(onboardingPath);
    }
  }, [guard, p.params.influencerId]);

  return (
    <homeVM.ValueProvider
      params={p.params}
      renderer={(vm) => <HomeView {...vm} />}
    />
  );
};
